import styled from 'styled-components';

export const Root = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Row = styled.div`
    display: flex;
    flex-direction: row;
    flex: 1 0 100%;
    flex-wrap: wrap;

    & > div {
        ${({ childCount }) => `flex: 1 0 ${100 / childCount}%;`}
        max-width: 150px;

        &:not(:first-child) {
            padding-left: 5px;
            box-sizing: border-box;
        }
    }
`;

export const Separator = styled.div`
    width: 0;
`;
